import axios, { AxiosError } from 'axios';
import qs from 'qs';

const instance = axios.create();

// axios 默认配置
instance.defaults.timeout = 30 * 1000;

// 请求拦截器
instance.interceptors.request.use(
  async (config) => {
    if (!config.headers) {
      config.headers = {};
    }

    // accessToken 带入请求头
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // get 类型的请求, 将参数格式化后在发送, 不然接口会报错
    if (config.method?.toLocaleLowerCase() === 'get') {
      config.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });
    }

    return config;
  },
  (error) => Promise.reject(error.message)
);

// axios 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) => Promise.resolve(res.data),
  // 请求失败
  async (error: AxiosError) => {
    if (!error.config.headers) {
      error.config.headers = {};
    }
    if (error.response) {
      switch (error.response.status) {
        // 401 未能验证用户身份
        case 401:
          // 删除 accessToken
          localStorage.removeItem('accessToken');
          // 刷新页面
          window.location.reload();
          break;
        default:
          break;
      }
    } else {
      // 请求超时或未知错误从新发起请求
      let retryInfo = error.config.headers.retryInfo as any;

      if (!retryInfo) {
        // 将重新发起请求的信息设置到 headers 回调需要
        retryInfo = {
          // 当前重新发起请求次数
          currentRetryCounnt: 0,
          // 最大重新发起请求次数
          maxRetryCount: 2,
          // 重新发起请求延迟
          retryDelay: 500,
        };
        error.config.headers.retryInfo = retryInfo;
      }

      // 验证是否已经到达最大重新发起请求次数
      if (retryInfo.currentRetryCounnt >= retryInfo.maxRetryCount) {
        console.log(`重新发起请求失败，地址: ${error.config.url}`);
        console.log(error.message);
        return Promise.reject(error.message);
      }

      // 自增
      retryInfo.currentRetryCounnt += 1;

      // 延迟重新发起请求
      const backoff = new Promise<void>((resolve) => {
        setTimeout(() => resolve(), retryInfo.retryDelay);
      });

      return backoff.then(() => {
        console.log(`重新发起请求中，第 ${retryInfo.currentRetryCounnt} 次，地址: ${error.config.url}`);

        return instance(error.config);
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
